import React from 'react';
// ANTD

import Card from 'antd/lib/card';

const Title = () => <div style={s.preview}>SIGNATURE PREVIEW</div>;

const SignaturePreview = ({ signatureText }) => (
  <div style={s.container}>
    <Card title={<Title />} style={{ height: '100%' }}>
      <div style={s.signatureContainer}>
        <p className="signature-text" style={{ fontSize: 20 }}>
          {signatureText}
        </p>
      </div>
    </Card>
  </div>
);

const s = {
  container: {
    height: '100%',
  },
  signatureContainer: {
    borderBottom: '1px solid #ddd',
    width: '100%',
  },
  preview: {
    minHeight: 25,
    color: '#999',
    textAlign: 'center',
    fontSize: 11,
  },
};

export default SignaturePreview;



// WEBPACK FOOTER //
// ./src/routes/contract-sign/ContractPDF/SignatureModal/SignaturePreview/index.js